<template>
  <div class="chart-content">
    <div class="doughnut-chart-container">
      <DoughnutChartBaseWrapper class="chart" :legend-element-id="legendElementId" :title="title" :data="data" />
    </div>
    <div :id="legendElementId" class="legend-container"></div>
  </div>
</template>

<script lang="ts" setup>
import { Data } from '../../models';
import DoughnutChartBaseWrapper from './DoughnutChartBaseWrapper.vue';
import { computed, PropType } from 'vue';

const props = defineProps({
  reportId: {
    type: String,
    required: true,
  },
  data: {
    type: Object as PropType<Data>,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
});

const legendElementId = computed(() => 'legendContainer-' + props.reportId);
</script>

<style scoped lang="scss">
@use '@/features/reports/components/reports.scss' as *;

.chart-content {
  flex: 1;
  display: flex;
  padding: 0px 6px;
}

.totals-doughnut-chart {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.doughnut-chart-container {
  min-width: 237px;
  max-width: 237px;
  display: flex;
  align-items: center;
}

.legend-container {
  margin: auto;
  flex: 1;
  padding-left: 1rem;
}
</style>
